export default __webpack_public_path__ + "static/media/6.a194e421.jpg";